module.exports = __webpack_public_path__ + "static/media/DINOT-Bold.9f02a0a6.woff2";